import { useLang } from "@/i18n/LanguageContext";
import { PRIVACY_POLICY_CONTENT } from "@/i18n/privacyPolicyContent";
import LegalDocumentPage from "@/components/legal/LegalDocumentPage";

export default function PrivacyPolicy() {
  const { lang } = useLang();
  const content = PRIVACY_POLICY_CONTENT[lang] || PRIVACY_POLICY_CONTENT.es;

  return (
    <LegalDocumentPage content={content} testId="privacy-policy-page" htmlLang={lang} />
  );
}
